Ext.define('SA.VectorMapExportScaleBarOverlay', {
    alias: 'widget.vector-map-export-scale-bar-overlay',
    extend: 'Ext.Component',

    cls: 'sa-vector-map-export-overlay',
    constrain: true,
    draggable: true,
    floating: true,
    overCls: 'sa-vector-map-export-overlay-over',
    toFrontOnShow: false,

    afterRender() {
        this.callParent();

        this.getEl().addClsOnClick('sa-vector-map-export-overlay-drag');
    },

    getRecord() {
        return this.details.getScaleBar();
    },

    onMouseDown: Ext.emptyFn,

    refresh() {
        var {details} = this,
            extent = SA.VectorMapExtent.fromXYBounds(this.extent.getBounds()),
            modelState = this.model.getState(),
            pageWidth = this.page.getWidth(),
            params = SA.VectorMapExportParams.forScaleBar({details, extent, modelState, pageWidth});

        this.svg?.remove();
        this.svg = this.getEl().dom.appendChild(SA.VectorMapExportScaleBar.getSvg(params));
    }
});